import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import {
  Fullscreen as FullscreenIcon,
  FullscreenExit as FullscreenExitIcon
} from '@mui/icons-material';

/**
 * Reusable full screen toggle button component
 * @param {Object} props - Component props
 * @param {boolean} props.isFullScreen - Current full screen state
 * @param {Function} props.onToggle - Toggle function
 * @param {string} props.size - Button size (small, medium, large)
 * @param {string} props.color - Button color
 * @param {Object} props.sx - Custom styles
 * @param {string} props.tooltipEnter - Tooltip text for enter full screen
 * @param {string} props.tooltipExit - Tooltip text for exit full screen
 * @returns {JSX.Element} Full screen button component
 */
const FullScreenButton = ({
  isFullScreen,
  onToggle,
  size = 'small',
  color = '#485869',
  sx = {},
  tooltipEnter = 'Enter full screen',
  tooltipExit = 'Exit full screen',
  ...props
}) => {
  const handleClick = (event) => {
    event.stopPropagation();
    onToggle();
  };

  return (
    <Tooltip title={isFullScreen ? tooltipExit : tooltipEnter}>
      <IconButton
        size={size}
        onClick={handleClick}
        sx={{
          color: color,
          ...sx
        }}
        {...props}
      >
        {isFullScreen ? (
          <FullscreenExitIcon fontSize={size} />
        ) : (
          <FullscreenIcon fontSize={size} />
        )}
      </IconButton>
    </Tooltip>
  );
};

export default FullScreenButton;